import React from "react";
import { HardHat, Pickaxe, Zap, Factory, Ship, Sprout, Building2, Truck, Cpu, FlaskConical, Layers } from "lucide-react";

// Custom pump-jack ("oil drill") icon — lucide has no equivalent.
function OilRig({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 20h18" />
      <path d="M8.5 20 12 9.8 15.5 20" />
      <circle cx="12" cy="9.8" r="1" />
      <path d="M5.5 7.6 18.5 11.6" />
      <path d="M5.5 7.6V20" />
      <circle cx="18.6" cy="11.7" r="1.4" />
    </svg>
  );
}

const RULES = [
  [/(construction|infrastructure|build)/, HardHat],
  [/(mining|mineral|mine)/, Pickaxe],
  [/(oil|gas|petro|fuel|drill|rig)/, OilRig],
  [/(power|electric|renewable|solar|energy)/, Zap],
  [/(manufactur|industrial|factory)/, Factory],
  [/(marine|ship|port|maritime|logistic|transport|freight)/, Ship],
  [/(agri|farm|crop)/, Sprout],
  [/(chem|pharma|lab)/, FlaskConical],
  [/(tech|it|software|electronic)/, Cpu],
  [/(fleet|haul|truck)/, Truck],
  [/(property|real estate|estate)/, Building2],
];

export function industryIcon(valueOrLabel) {
  const s = (valueOrLabel || "").toLowerCase();
  for (const [re, Icon] of RULES) {
    if (re.test(s)) return Icon;
  }
  return Layers;
}
